import { DELETE_DMX_PROFILE, DELETE_DMX_PROFILE_SUCCESSFUL, DELETE_DMX_PROFILE_FAILED } from './actionTypes';

const initialState = {
  deleteDmxProfileError: null,
  messageDmxProfile: null,
  loadingDeleteDmxProfile: false,
};

const deleteProfile = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_DMX_PROFILE:
      state = { ...state, loadingDeleteDmxProfile: true, deleteDmxProfileError: null };
      break;
    case DELETE_DMX_PROFILE_SUCCESSFUL:
      state = { ...state, loadingDeleteDmxProfile: false, messageDmxProfile: action.payload, deleteDmxProfileError: null };
      break;
    case DELETE_DMX_PROFILE_FAILED:
      state = { ...state, messageDmxProfile: null, loadingDeleteDmxProfile: false, deleteDmxProfileError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default deleteProfile;
